module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-user-contact"><div id="userCon"><div class="tit">填写联系方式</div><div class="userInfo"></div><div class="sub submit" onclick="lottery.setUserContact()">确认提交</div><div class="contact-hint"><span>提交后如需修改地址，请在本活动页面【获奖记录】中操作</span></div></div><div id="success-submit">提交成功</div></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./modules/mask/user.contact.html
// module id = 30
// module chunks = 0